function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { _michelinOld } from "../../../themes/michelin/_oldTheme";
/**
 * intentional dangle -- deprecated theme
 */
// eslint-disable-next-line no-underscore-dangle

export var _createOldMichelinTheme = function _createOldMichelinTheme(options) {
  var _options$palette;

  var muiThemeOptions = {
    palette: _extends({}, (_options$palette = options == null ? void 0 : options.palette) != null ? _options$palette : {}, {
      type: 'light'
    })
  };
  return _michelinOld(muiThemeOptions);
};